import ImpactPill from "@/components/Impact/ImpactPill";
import Table, { Column } from "@/components/Table/Table";
import { formatMass } from "@/pages/dashboard/utils/formatters";
import { ReactNode } from "react";
import { BomItem } from "../../useProducts";
import BomRow from "./BomRow";
import styles from "./BomRow.module.scss";

export default function BillOfMaterialsTable({
  data,
  loading,
  noDataMessage,
}: {
  data?: BomItem;
  loading?: boolean;
  noDataMessage?: ReactNode;
}) {
  const columns: Column<BomItem>[] = [
    {
      key: "name",
      label: "Material",
      minWidth: "376px",
      maxWidth: "376px",
      renderer: (record) => (
        <div className={styles["material-name"]}>
          <span>{record.name}</span>
          <span className={styles["supplier"]}>
            {[record.supplier_name, record.supplier_address].filter((x) => x).join(" - ")}
          </span>
        </div>
      ),
    },
    {
      key: "quantity",
      label: "Quantity",
      minWidth: "100px",
    },
    {
      key: "total_quantity",
      label: "Total quantity",
      minWidth: "100px",
    },
    {
      key: "unit",
      label: "Unit",
      minWidth: "100px",
    },
    {
      key: "total_mass",
      label: "Total mass",
      minWidth: "100px",
      renderer: (record) => formatMass(record.total_mass),
    },
    {
      key: "impact",
      label: "Impact",
      minWidth: "300px",
      renderer: (record) => (
        <ImpactPill
          type="borderless"
          loading={false}
          impact={record.impact}
          showDate={false}
          incomplete={record.status === "incomplete"}
          incompleteTooltip={
            record.status === "incomplete"
              ? "Material needs an impact reference and/or unit conversion to calculate impact."
              : undefined
          }
        />
      ),
    },
  ];

  const bomData = data?.children.sort((a, b) => {
    if (a.children.length > b.children.length) return 1;
    if (a.children.length < b.children.length) return -1;
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  });

  return (
    <Table<BomItem>
      loading={loading}
      rowKey="id"
      data={bomData}
      columns={columns}
      rowRenderer={BomRow}
      rowLink={(record) => "/materials/" + record.id}
      emptyState={{
        noResultsMessage: noDataMessage || "No bill of materials available.",
      }}
    />
  );
}
